'use client';

import type { CollaboratorOverheadResponse } from '@/app/models/overhead';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Column } from '../common/DataTable';
import ExpandableDataTable from '../common/ExpandableDataTable';
import OverheadCollaboratorTable from './OverheadCollaboratorTable';

type EventTableParams = {
  rows: CollaboratorOverheadResponse[];
};

export default function OverheadDetailsTable(props: EventTableParams) {
  const { rows } = props;
  const { t } = useTranslation(['overhead', 'common']);

  const columns: Column[] = [
    { key: 'collaborator', label: t('collaborator'), width: '720px' },
    { key: 'salary', label: `${t('salary')}`, width: '235px' },
    { key: 'salaryToConsider', label: `${t('salary.to.consider')}` },
    { key: 'valueToSharing', label: `${t('value.to.sharing')}` },
    { key: 'allocationOrigin', label: `${t('allocation.origin')}`, align: 'center' },
    { key: 'toAllocate', label: `${t('to.allocate')}`, align: 'center' },
    { key: 'percAtOrigin', label: `${t('perc.at.origin')}`, align: 'center' },
  ];

  // For expandable rows, we need a special renderRow function that returns the OverheadCollaboratorTable component
  const renderRow = (row: CollaboratorOverheadResponse) => <OverheadCollaboratorTable row={row} />;

  // Use badge as the unique key
  const getRowKey = (row: CollaboratorOverheadResponse) => row.badge;

  return (
    <Box sx={{ width: '100%' }}>
      <ExpandableDataTable
        columns={columns}
        data={rows}
        renderRow={renderRow}
        getRowKey={getRowKey}
        emptyMessage={t('common:no.data.for.the.chosen.period.and.search.term')}
        maxHeight="35rem"
        stickyHeader
      />
    </Box>
  );
}
